import { render, staticRenderFns } from "./ProofreadBtn.vue?vue&type=template&id=458305d2&"
import script from "./ProofreadBtn.vue?vue&type=script&lang=js&"
export * from "./ProofreadBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports